import Base from './Base';
import moment from 'moment';
import PendingMentions from '../collections/PendingMentions';

export default class MessageReassign extends Base {
    constructor(item) {
        super(item);

        this.type = 'reassign';
        this.status = 'reassign';
        this.contact = {};
        this.previews = [];
        this.pending_mentions = new PendingMentions([]).models;
    }

    getParsedShortUrls(shortenerDomains) {
        // was added for backward compatibility. before it was always empty
        return [];
    }

    get idReassign() {
        return +(this.conversation_id.toString() + this.id.toString()) + '-reassign';
    }

    get currentUserfullName() {
        let fullName = '';

        if (this.current_user.first_name) {
            fullName += this.current_user.first_name;
        }

        if (this.current_user.last_name) {
            if (this.current_user.first_name) {
                fullName += ' ';
            }

            fullName += this.current_user.last_name;
        }

        return fullName;
    }

    get isVoicemail() {
        if (!this.record) return false;

        return this.record.is_voicemail;
    }

    get changerUserfullName() {
        let fullName = '';

        if (this.changer_user.first_name) {
            fullName += this.changer_user.first_name;
        }

        if (this.changer_user.last_name) {
            if (this.changer_user.first_name) {
                fullName += ' ';
            }

            fullName += this.changer_user.last_name;
        }

        return fullName;
    }

    get createdTimestamp() {
        return moment(this.created_at).valueOf();
    }

    get messageTimestamp() {
        const timestamp = this.send_at || this.created_at;

        return moment(timestamp).valueOf();
    }

    get createdTimestampMinute() {
        return Math.floor(this.createdTimestamp / 1000 / 60);
    }

    get body() {
        if (!this.currentUserfullName) {
            return `${this.changerUserfullName} marked conversation as Unassigned.`;
        }

        return `${this.changerUserfullName} assigned the conversation to ${this.currentUserfullName}`;
    }

    get isReassignType() {
        return this.type === 'reassign';
    }
}
